import classNames from "classnames";
import styles from "./DetailsRow.module.css";

type Props = {
  label: string;
  value?: string | string[] | null;
  tooltip?: React.ReactNode;
  valueClassName?: string;
  className?: string;
};

type ValueProps = Pick<Props, "value" | "valueClassName" | "tooltip">;

function RenderValue({ value, valueClassName, tooltip }: ValueProps) {
  if (value && Array.isArray(value)) {
    return (
      <div>
        {value.map((v, index) => (
          <div
            key={`${v}-${index}`}
            className={classNames(styles.value, valueClassName)}
          >
            {v}
          </div>
        ))}
        {tooltip ? tooltip : null}
      </div>
    );
  }

  return (
    <span className={classNames(styles.value, valueClassName)}>
      {value ? value : "-"}
      {tooltip ? tooltip : null}
    </span>
  );
}

export function DetailsRow({ label, className, ...props }: Props) {
  return (
    <div className={classNames(styles.row, className)}>
      <span className={styles.label}>{label}</span>
      <RenderValue {...props} />
    </div>
  );
}
